import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: resolve => require(['@/pages/Home.vue'], resolve)
    },
    {
      path: '/guide',
      name: 'guide',
      component: resolve => require(['@/pages/Guide.vue'], resolve)
    },
    {
      path: '/select',
      name: 'select',
      component: resolve => require(['@/pages/Select.vue'], resolve)
    },
    {
      path: '/result',
      name: 'result',
      component: resolve => require(['@/pages/Result.vue'], resolve)
    },
    {
      path: '*',
      redirect: '/home',
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js